// extracted by mini-css-extract-plugin
module.exports = {"resumeContainer":"styles_resumeContainer__f8Mx_","textContainer":"styles_textContainer__2vwH2","propertyDetailsButton":"styles_propertyDetailsButton__2-47w"};